import VMAP from '@dailymotion/vmap';

export const fetchVmapUrl = (url) => new Promise((resolve, reject) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url);
  xhr.send();
  xhr.onreadystatechange = () => {
    if (xhr.readyState === xhr.DONE) {
      if (xhr.status === 200) {
        // Get a parsed VMAP object. The constructor throws on anything that isn't a VMAP document
        // (an empty body, HTML, a VAST), and a throw left here would never settle the promise.
        try {
          resolve(new VMAP(xhr.responseXML));
        } catch (e) {
          reject(e);
        }
      } else {
        reject(new Error('Error'));
      }
    }
  };
});
